import {
  ITrainingLessonRef,
  ITrainingModule,
} from '../interfaces/i-training';

/**
 * Achata os módulos em uma trilha linear de aulas, já com a numeração derivada
 * da ordem do JSON. É essa lista que alimenta a navegação "Aula anterior /
 * Próxima aula" e a busca da aula ativa.
 */
export function flattenTrainingLessons(
  modules: ITrainingModule[]
): ITrainingLessonRef[] {
  const flatLessons: ITrainingLessonRef[] = [];

  modules.forEach((module) => {
    (module.aulas || []).forEach((lesson, lessonIndex) => {
      flatLessons.push({
        lesson,
        module,
        lessonNumber: lessonIndex + 1,
        flatIndex: flatLessons.length,
      });
    });
  });

  return flatLessons;
}
